import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import IconButton from '@material-ui/core/IconButton';
import { Close as CloseIcon } from '@material-ui/icons';
import { useDialogStyles } from '../dialog-common';

const cancelText = i18n._(t`Close`);

const NgpOneButtonDialog = (props) => {
    const { title, children, open, setOpen, cancelButtonText = cancelText, closeInTitleBar = true } = props;
    const classes = useDialogStyles();

    return (
        <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
            <DialogTitle id="confirm-dialog">
                {title}
                {closeInTitleBar && (
                    <IconButton
                        aria-label="cancel"
                        className={classes.closeButton}
                        onClick={() => setOpen(false)}
                        tabIndex={-1}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>{cancelButtonText}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default NgpOneButtonDialog;
